import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export function ProtectedRoute({ children }) {
  const { status } = useAuth();
  const location = useLocation();
  if (status === "loading") {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="auth-loading">
        <div className="q-glass rounded-2xl px-6 py-4 flex items-center gap-3">
          <span className="h-2 w-2 rounded-full q-accent-bg animate-pulse" />
          <span className="text-sm text-slate-300">Cargando tu sesión...</span>
        </div>
      </div>
    );
  }
  if (status !== "authed") {
    // Preserve query string (e.g. `?ref=<tag>`) so viral share links from
    // `${origin}/?ref=<tag>` land on /auth?ref=<tag> and the AuthPage chip
    // can pick it up.
    return <Navigate to={{ pathname: "/auth", search: location.search }} replace />;
  }
  return children;
}

export function GuestOnlyRoute({ children }) {
  const { status } = useAuth();
  const location = useLocation();
  if (status === "loading") {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="auth-loading">
        <div className="q-glass rounded-2xl px-6 py-4 flex items-center gap-3">
          <span className="h-2 w-2 rounded-full q-accent-bg animate-pulse" />
          <span className="text-sm text-slate-300">Cargando...</span>
        </div>
      </div>
    );
  }
  if (status === "authed") {
    // Same rationale in reverse: if an authed user hits `/auth?ref=<tag>`
    // we don't need to preserve the ref (they're already registered).
    // Keep the redirect clean.
    return <Navigate to="/" replace />;
  }
  return children;
}
